<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/3 mb-base" v-show="$auth.checkRoles(geoRoles.readers)" >
        <vx-card  slot="no-body" :title="$t('Geo.NSR.Title')" class="text-center greet-user mb-5" v-show="$auth.checkRoles(geoRoles.readers)">
          <menu-control :items="nsrItems">
          </menu-control>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/3 mb-base" v-show="$auth.checkRoles(geoRoles.readers)">
        <vx-card slot="no-body"  :title="$t('Geo.QAQC.Title')"  class="text-center greet-user" v-show="$auth.checkRoles(geoRoles.readers)">
          <menu-control :items="qaQcItems">
          </menu-control>
        </vx-card>
      </div>
      <div class="vx-col w-full md:w-1/3 mb-base" v-show="$auth.checkRoles(['MRMRReaders', 'Admin'])">
        <vx-card  slot="no-body" :title="$t('MRMR.Statement.Title')" class="text-center greet-user mb-5" v-show="$auth.checkRoles(['MRMRReaders', 'Admin'])">
          <ul class="menu_line">
            <menu-item :roles="mrmrRoles.consolidation" icon="ClockIcon" :title="$t('MRMR.Period.Title')" link="/mrmr/periods" />
            <menu-item :roles="mrmrRoles.readers" fontAwesomeIcon="tasks" :title="$t('MRMR.Statement.Title')" link="/mrmr/statements" />
            <menu-item :roles="mrmrRoles.consolidation" fontAwesomeIcon="tasks" :title="$t('MRMR.Qp.Title')" link="/mrmr/qps" />
            <menu-item :roles="mrmrRoles.consolidation" fontAwesomeIcon="tasks" :title="$t('MRMR.ProfessionalOrder.Title')" link="/mrmr/professional-orders" />
            <li v-if="$auth.checkRoles(['MRMRReaders', 'MRMRConsolidation', 'Admin'])">
             
                <div class="menu-icon bg-secondary">
                  <feather-icon icon="BarChart2Icon" svgClasses="text-white stroke-current w-5 h-5" />
                </div>
                <div class="menu-text">
                  <router-link to="/mrmr/statements/reports/dashboard" v-if="$auth.checkRoles(['MRMRReaders','MRMRConsolidation', 'Admin'])">{{ $t('MRMR.Report.Dashboard') }}</router-link>
                </div>
                 <div class="menu-text">
                  <router-link v-if="$auth.checkRoles(['MRMRReaders', 'MRMRConsolidation', 'Admin'])" to="/mrmr/statements/reports/consolidated">{{ $t('MRMR.Report.Consolidated') }}</router-link>
                </div>
                 <div class="menu-text">
                  <router-link v-if="$auth.checkRoles(['MRMRReaders', 'MRMRConsolidation', 'Admin'])" to="/mrmr/statements/reports/percommodity">{{ $t('MRMR.Report.PerCommodity') }}</router-link>
                </div>
            </li>
            <menu-item :roles="mrmrRoles.consolidation" icon="FileTextIcon" :title="$t('MRMR.Statement.RawData')" link="/mrmr/statements/rawdata" />
            <li v-if="$auth.checkRoles(['MRMRReaders', 'MRMRCollaborators', 'Admin'])">
              <div class="menu-icon bg-secondary">
                <feather-icon icon="BarChart2Icon" svgClasses="text-white stroke-current w-5 h-5" />
              </div>
              <div class="menu-text">
                <router-link v-if="$auth.checkRoles(['MRMRReaders', 'MRMRCollaborators', 'Admin'])" to="/mrmr/variances">{{ $t('MRMR.Variances.Title') }}</router-link>
              </div>
            </li>
          </ul>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>

import mrmrRoles from './MRMR/roles.js'
import geoRoles from './roles.js'
import menuItem from '@/app/shared/components/lists/menu-item.vue'
import menuControl from '@/app/shared/components/lists/menu.vue'

export default {
  components: {
    menuItem,
    menuControl
  },
  data () {
    return {
      mrmrRoles,
      geoRoles,
      nsrItems : [ 
        {
          roles : mrmrRoles.consolidation,
          icon : "DollarSignIcon",
          to : "/mrmr/scenarios",
          i18nTitle : "GeoScenarioPage.Title"
        },
        {
          roles : mrmrRoles.consolidation,
          icon : "BarChart2Icon",
          to : "/mrmr/nsr",
          i18nTitle : "Geo.NSR.Analytics.Title"
        }
      ],
      qaQcItems : [ 
        {
          roles : geoRoles.readers,
          icon : "BarChart2Icon",
          to : "/mrmr/geostats",
          i18nTitle : "Geo.QAQC.Title"
        }
      ]
    }
  }
}
</script>


<style lang="scss">
 .tutorialPopup {
    .vs-popup {
      width: 673px !important;
    }
} 
</style>